<fr-isc-form Id="delete-user" [FDN]="FDN" [formModel]="data" [mode]="'edit'" [buttons]="buttons">
</fr-isc-form>
